import { LabRemoteConfigKeys } from 'constants/lab'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'

function hasShowNewBadge(payload: unknown): payload is { showNewBadge: boolean } {
  return (
    typeof payload === 'object' &&
    payload !== null &&
    typeof (payload as { showNewBadge?: unknown }).showNewBadge === 'boolean'
  )
}

/**
 * Whether the launch "NEW" badge still shows on the credit card hamburger row.
 *
 * Read here rather than resolved onto the shared nav item, because the nav item feeds both the
 * hamburger row and the desktop products bar / "More" dropdown — and the design only puts a badge
 * on the hamburger row.
 *
 * Lab omits disabled or out-of-audience payloads, so a missing payload hides the badge, which is
 * how the badge gets retired at the end of the launch window.
 */
function useLoyaltyCreditCardNewBadge(): boolean {
  const config = useLabRemoteConfig(LabRemoteConfigKeys.societeCreditCardConfig)

  return hasShowNewBadge(config?.value) && config.value.showNewBadge
}

export default useLoyaltyCreditCardNewBadge
